/**
 * Utilitaire partage pour les regles de visibilite du statut Uber.
 * Centralise la logique de cliquabilite de UberStatusCell
 * et le predicat de visibilite de l'action d'extraction burger-menu.
 */

/**
 * Statuts Uber pour lesquels la cellule de statut est cliquable
 * (i.e. le bouton d'action est affiche dans UberStatusCell).
 */
export const CLICKABLE_UBER_STATUSES = ["canceled", "pending", "pickup"];

/**
 * Retourne le premier external shipping job de la tache, ou null.
 * @param {Object} task
 * @returns {Object|null}
 */
function getFirstExternalJob(task) {
  if (task.external_shipping_jobs && task.external_shipping_jobs.length > 0) {
    return task.external_shipping_jobs[0];
  }
  return null;
}

/**
 * Determine si la cellule de statut Uber est cliquable pour une tache donnee.
 * Reproduit la regle actuellement codee en dur dans UberStatusCell :
 * - cliquable si statut dans ["canceled", "pending", "pickup"],
 * - non cliquable sinon (badge passif ou pas de job Uber),
 * - jamais cliquable si la tache est en cours de resolution.
 *
 * @param {Object} task - La tache a evaluer
 * @returns {boolean} true si le statut Uber rend la cellule cliquable
 */
export function isUberStatusClickable(task) {
  var externalJob = getFirstExternalJob(task);
  if (!externalJob) {
    return false;
  }
  if (task.resolving === true) {
    return false;
  }
  return CLICKABLE_UBER_STATUSES.indexOf(externalJob.status) !== -1;
}

/**
 * Determine si l'action d'extraction Uber doit etre visible dans le burger-menu.
 * L'action est affichee quand :
 * - la tache possede un external_shipping_job (contexte Uber),
 * - la cellule de statut Uber n'est PAS cliquable (statut hors canceled/pending/pickup),
 * - la tache n'est pas en cours de resolution.
 *
 * En d'autres termes, c'est le complement de isUberStatusClickable pour les taches
 * qui ont un job Uber : le menu prend le relais quand la cellule ne propose plus d'action.
 *
 * @param {Object} task - La tache a evaluer
 * @returns {boolean} true si l'action d'extraction doit apparaitre dans le menu
 */
export function shouldShowUberExtractAction(task) {
  var externalJob = getFirstExternalJob(task);
  if (!externalJob) {
    return false;
  }
  if (task.resolving === true) {
    return false;
  }
  return CLICKABLE_UBER_STATUSES.indexOf(externalJob.status) === -1;
}
